import { render, staticRenderFns } from "./addTaskPage.vue?vue&type=template&id=2c3d750c&scoped=true&"
import script from "./addTaskPage.vue?vue&type=script&lang=tsx&"
export * from "./addTaskPage.vue?vue&type=script&lang=tsx&"
import style0 from "./addTaskPage.vue?vue&type=style&index=0&id=2c3d750c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d750c",
  null
  
)

export default component.exports